const API = {
  POST_UPDATE_EXPERT: {
    path: '/expert/update-profile',
    method: 'POST',
  },
  STRIPE_CONNECT: {
    path: '/stripe/connect/generate-url',
    method: 'POST',
  },
  POST_ASSIGN_CATEGORIES: {
    path: '/categories/assign',
    method: 'POST',
  },
};
export default API;
